export default {
  id: 'WebsiteSideMenu',
  code: 'CN',
  text: {
    'Language': '网站语言',
    'Website Settings': '网站设置',
    'Website URL': '网站地址',
    'Nav Settings': '导航设置',
    'Theme Settings': '模版设置',
    'Select Theme': '模版选择',
    'Edit Page': '页面编辑',
    'Edit Form': '表格编辑',
    'Header Navigation': '顶部导航',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Website/locale.js